import React from "react";
import { AddFlex, Gap } from "../../reusableStyles";

function InstaPreviewChats({ chats, insta_photo_url }) {
  return (
    <AddFlex
      flexDirection="column"
      grow="1"
      gap="10px"
      padding="10px"
      style={{ overflow: "scroll" }}
    >
      {chats.map((chat) => {
        if (chat.isDivider) {
          return (
            <AddFlex
              justifyContent="center"
              style={{
                color: "#9ca3af",
                fontSize: "9px",
                fontStyle: "italic",
                padding: "4px 0",
                letterSpacing: "0.3px",
              }}
            >
              {chat.message}
            </AddFlex>
          );
        }
        return (
        <AddFlex alignItems="flex-end" gap="10px">
          {!chat.isClient && <Gap />}
          {chat.isClient && (
            <img
              src={insta_photo_url}
              style={{
                width: "22px",
                height: "22px",
                backgroundColor: "white",
                borderRadius: "100%",
              }}
            ></img>
          )}
          <AddFlex
            borderRadius="12px"
            backgroundColor={chat.isClient ? "#262626" : "#6C4AEC"}
            style={{
              color: "white",
              fontSize: "10px",
              maxWidth: "70%",
              overflow: "hidden",
            }}
            padding={chat.imageUrl ? "0px" : "10px"}
            flexDirection="column"
            gap="0px"
          >
            {chat.imageUrl && (
              <img
                src={chat.imageUrl}
                alt=""
                style={{
                  width: "100%",
                  aspectRatio: "1.91/1",
                  objectFit: "cover",
                }}
              />
            )}
            <AddFlex flexDirection="column" gap="10px" padding="10px">
            {chat.message}
            {chat.buttons && (
              <AddFlex flexDirection="column" gap="5px">
                {chat.buttons?.map((button) => (
                  <AddFlex
                    style={{
                      backgroundColor: "#404040",
                      color: "white",
                      padding: "5px 10px",
                      alignItems: "center",
                      justifyContent: "center",
                      borderRadius: "6px",
                    }}
                  >
                    {button.buttonText}
                  </AddFlex>
                ))}
              </AddFlex>
            )}
            </AddFlex>
          </AddFlex>
        </AddFlex>
      );
      })}
    </AddFlex>
  );
}

export default InstaPreviewChats;
